<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="title"
    :visible="visible"
    style="overflow: hidden"
    top="20px"
    width="65%"
    @close="handleEditDialogClose"
  >


    <div style="overflow-y: auto; height: 70vh">
      <el-form
        :model="formData"
        label-width="130px"
        :rules="formRule"
        ref="form"
        size="mini"
        class="locale-form"
      >
        <el-row class="form-part">
          <el-col :span="3" class="form-part-title">
            <div class="wordWrapClass">基本信息</div>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="locale_type" label="监测类型">
              <el-select v-model="formData.locale_type" @change="selectChange" placeholder="请选择监测类型" style="width: 100%">
                <el-option-group
                  v-for="(group, index) in localeTypes"
                  :key="group.label"
                  :label="group.label"
                >
                  <el-option
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="title == '编辑' && shouldDisableOption(index)"
                    >
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item prop="contact" label="联系人">
              <el-input
                @change="hasChange"
                v-model.trim="formData.contact"
                placeholder="请输入联系人"
                :disabled="isView"/>
            </el-form-item>
            <el-form-item prop="area_id" label="所属地区">
              <el-cascader
                style="width: 100%"
                placeholder="关键字"
                v-model.trim="formData.area_id"
                @change="hasChange"
                :options="areaTree"
                :props="areaProps"
                filterable
                :disabled="isView"
              />
            </el-form-item>
            <el-form-item prop="owner" label="所属单位">
              <el-cascader
                style="width: 100%"
                placeholder="关键字"
                v-model.trim="formData.owner"
                @change="handleOwnerChange"
                :options="customerTree"
                :props="props"
                filterable
                :disabled="isView"
              />
            </el-form-item>
            <el-form-item prop="stove_length" label="集气罩长">
              <el-input
                @change="hasChange"
                placeholder="请输入集气罩长(m)"
                v-model.number="formData.stove_length"
                :disabled="isView"
              />
            </el-form-item>
            <el-form-item prop="stove_area" label="集气灶面积">
              <el-input
                @change="hasChange"
                placeholder="请输入集气灶面积(m²)"
                v-model.trim="formData.stove_area"
                :disabled="isView"
              />
            </el-form-item>
            <el-form-item prop="cuisine" label="选择菜系">
              <el-cascader
                :disabled="isView"
                v-model="formData.cuisine"
                :options="cuisine"
                @change="hasChange"
                style="width: 100%"></el-cascader>
            </el-form-item>
            <el-form-item prop="scale" label="企业类型">
              <el-select
                style="width: 100%"
                @change="hasChange"
                placeholder="请选择企业类型"
                v-model.trim="formData.scale"
                :disabled="isView">
                <el-option value="大" label="大"/>
                <el-option value="中" label="中"/>
                <el-option value="小" label="小"/>
              </el-select>
            </el-form-item>
            <el-form-item prop="status_of_record" label="监测点状态">
              <el-radio-group
                @input="statusChange"
                v-model="formData.status_name"
                size="mini">
                <el-radio-button label="正常"/>
                <el-radio-button label="下线"/>
                <el-radio-button label="歇业"/>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="坐标拾取">
              <a
                style=" color: #409eff; text-decoration: none;"
                target="_blank"
                v-if="!isView"
                href="https://api.map.baidu.com/lbsapi/getpoint/index.html">
                百度坐标拾取系统
              </a>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="name" label="监测点名称">
              <el-input
                placeholder="请输入监测点名称"
                @change="hasChange"
                v-model.trim="formData.name"
                :disabled="isView"/>
            </el-form-item>
            <el-form-item prop="mobile" label="联系电话">
              <el-input
                @change="hasChange"
                v-model.trim="formData.mobile"
                placeholder="请输入联系电话"
                :disabled="isView"/>
            </el-form-item>
            <el-form-item prop="addr" label="详细地址">
              <el-input
                @change="hasChange"
                placeholder="请输入详细地址"
                v-model.trim="formData.addr"
                :disabled="isView"/>
            </el-form-item>
            <el-form-item prop="lng" label="经度">
              <el-input
                @change="hasChange"
                placeholder="可直接粘贴到此处"
                v-model.trim="formData.lng"
                @keyup.ctrl.86.native="handlePaste"
                :disabled="isView"
              />
            </el-form-item>
            <el-form-item prop="lat" label="纬度">
              <el-input
                @change="hasChange"
                v-model.trim="formData.lat"
                :disabled="isView"/>
            </el-form-item>
            <el-form-item prop="stove_width" label="集气罩宽">
              <el-input
                @change="hasChange"
                placeholder="请输入集气罩宽"
                v-model.number="formData.stove_width"
                :disabled="isView"
              />
            </el-form-item>
            <el-form-item prop="exhaust_time" label="日均排烟时间">
              <el-input
                @change="hasChange"
                placeholder="请输入日均排烟时间(h)"
                v-model.trim="formData.exhaust_time"
                :disabled="isView"
              />
            </el-form-item>
            <el-form-item prop="stove_num" label="基准灶头数">
              <el-input
                @change="hasChange"
                placeholder="请输入基准灶头数"
                v-model.number="formData.stove_num"
                :disabled="isView"
              />
            </el-form-item>
            <el-form-item prop="management_types" label="经营类型">
              <el-cascader
                :disabled="isView"
                v-model="formData.management_types"
                :options="managementTypes"
                @change="hasChange"
                style="width: 100%"></el-cascader>
            </el-form-item>
            <el-form-item prop="maintainer_id" label="维保人员">
              <el-select
                style="width: 100%"
                @change="hasChange"
                placeholder="请选择维保人员"
                v-model="formData.maintainer_id"
                :disabled="isView">
                <el-option v-for="item in maintenanceList"
                           :key="item.Id"
                           :value="item.Id"
                           :label="item.Name"/>
              </el-select>
            </el-form-item>
            <template v-if="title == '编辑'">
              <el-form-item prop="filter_wash_day" label="净化器清洗天数">
                <el-input
                  @change="hasChange"
                  placeholder="请输入净化器清洗天数"
                  v-model.number="formData.filter_wash_day"
                  :disabled="isView"
                />
              </el-form-item>
            </template>
          </el-col>
        </el-row>
        <el-row class="form-part">
          <el-col :span="3" class="form-part-title">
            <div class="wordWrapClass">排放系统信息</div>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="fan_brand" label="风机品牌">
              <el-input
                @change="hasChange"
                v-model.trim="formData.fan_brand"
                :disabled="isView"
                placeholder="请输入风机品牌"/>
            </el-form-item>
            <el-form-item prop="fan_power" label="风机功率">
              <el-input
                @change="hasChange"
                v-model.number="formData.fan_power"
                :disabled="isView"
                placeholder="请输入风机功率(kW)"/>
            </el-form-item>
            <el-form-item prop="fan_speed" label="烟气流速">
              <el-input
                @change="hasChange"
                v-model.number="formData.fan_speed"
                :disabled="isView"
                placeholder="请输入风机功率(m/s)"/>
            </el-form-item>
            <el-form-item prop="filter_brand" label="净化器品牌">
              <el-input
                @change="hasChange"
                v-model.trim="formData.filter_brand"
                :disabled="isView"
                placeholder="请输入净化器品牌"/>
            </el-form-item>
            <el-form-item prop="purifying_rate" label="净化器净化率">
              <el-input
                @change="hasChange"
                v-model.number="formData.purifying_rate"
                :disabled="isView"
                placeholder="请输入净化器净化率"/>
            </el-form-item>
            <el-form-item prop="filter_power" label="净化器功率">
              <el-input
                @change="hasChange"
                v-model.number="formData.filter_power"
                :disabled="isView"
                placeholder="请输入净化器功率(kW)"/>
            </el-form-item>
          </el-col>

          <el-col :span="10">
            <el-form-item prop="fan_model" label="风机型号">
              <el-input
                @change="hasChange"
                v-model.trim="formData.fan_model"
                :disabled="isView"
                placeholder="请输入风机型号"/>
            </el-form-item>
            <el-form-item prop="fan_standard_current" label="风机标准电流">
              <el-input
                @change="hasChange"
                v-model.trim="formData.fan_standard_current"
                :disabled="isView"
                placeholder="请输入风机标准电流(A)"/>
            </el-form-item>
            <el-form-item prop="pipe_area" label="管道截面积">
              <el-input
                @change="hasChange"
                v-model.number="formData.pipe_area"
                :disabled="isView"
                placeholder="请输入管道截面积(m²)"/>
            </el-form-item>
            <el-form-item prop="filter_model" label="净化器型号">
              <el-input
                @change="hasChange"
                v-model.trim="formData.filter_model"
                :disabled="isView"
                placeholder="请输入净化器型号"/>
            </el-form-item>
            <el-form-item prop="fan_quantity" label="净化器风量">
              <el-input
                @change="hasChange"
                v-model.number="formData.fan_quantity"
                :disabled="isView"
                placeholder="请输入净化器风量(m³/h)"/>
            </el-form-item>
            <el-form-item prop="filter_standard_current" label="净化器标准电流">
              <el-input
                @change="hasChange"
                v-model.trim="formData.filter_standard_current"
                :disabled="isView"
                placeholder="请输入净化器标准电流(A)"/>
            </el-form-item>
          </el-col>
        </el-row>
        <template v-if="formData.type == 1">
        <el-row class="form-part">
          <el-col :span="3" class="form-part-title">
            <div class="wordWrapClass">监测仪信息</div>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="voc_factory_name" label="监测仪品牌">
              <el-select
                style="width: 100%"
                @change="handleFactorySelect"
                v-model.trim="formData.voc_factory_name"
                :disabled="isView"
                placeholder="请选择监测仪品牌">
                <el-option v-for="factory in factoryList"
                           :key="factory.factory_name"
                           :label="factory.factory_name"
                           :value="factory.factory_name"/>
              </el-select>
            </el-form-item>
            <el-form-item prop="principle" label="检测原理">
              <el-select
                @change="hasChange"
                v-model.trim="formData.principle"
                :disabled="isView"
                placeholder="请输入检测原理"
                style="width: 100%">
                <el-option value="光散射" label="光散射"/>
                <el-option value="电化学" label="电化学"/>
                <el-option value="其他" label="其他"/>
              </el-select>
            </el-form-item>
            <el-form-item prop="power_supply_mode" label="接电方式">
              <el-select
                @change="hasChange"
                v-model.trim="formData.power_supply_mode"
                :disabled="isView"
                placeholder="请输入接电方式"
                style="width: 100%">
                <el-option value="风机取电" label="风机取电"/>
                <el-option value="净化器取电" label="净化器取电"/>
                <el-option value="市电" label="市电"/>
              </el-select>
            </el-form-item>
            <el-form-item prop="fan_mn" label="风机监控编码" v-if="(this.formData.send_mode===2 ||(this.formData.send_mode===3 &&this.formData.power_supply_mode ==='净化器取电'))&&this.title ==='新增'">
              <el-input
                @change="hasChange"
                v-model.trim="formData.fan_mn"
                :disabled="isView"
                placeholder="请输入风机监控编码后8位后进行补全">
                <div slot="append" @click="addPrefix('风机')">补全</div>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="voc_factory_model_id" label="监测仪型号">
              <el-select
                style="width: 100%"
                @change="handleFactoryModelChange"
                v-model="formData.voc_factory_model_id"
                :disabled="isView"
                placeholder="请选择监测仪型号">
                <el-option v-for="(item, index) in factoryModelList"
                  :key="index"
                  :value="item.id"
                  :label="item.model_name"/>
              </el-select>
            </el-form-item>
            <el-form-item prop="send_mode" label="传输方式">
              <el-select
                @change="hasChange"
                v-model.number="formData.send_mode"
                :disabled="isView"
                placeholder="请输入传输方式"
                style="width: 100%">
                <el-option :value="1" label="合并传输"/>
                <el-option :value="2" label="独立传输"/>
                <el-option :value="3" label="两路传输"/>
              </el-select>
            </el-form-item>
            <el-form-item prop="voc_mn" label="监测仪编码" v-if="this.title ==='新增'">
              <el-input
                @change="hasChange"
                v-model.trim="formData.voc_mn"
                :disabled="isView"
                placeholder="请输入监测仪编码后8位后进行补全">
                <div slot="append" @click="addPrefix('监测仪')">补全</div>
              </el-input>
            </el-form-item>
            <el-form-item prop="filter_mn" label="净化器监控编码" v-if="(this.formData.send_mode===2 ||(this.formData.send_mode===3 &&this.formData.power_supply_mode ==='风机取电') ||(this.formData.send_mode===3 &&this.formData.power_supply_mode ==='市电'))&&this.title ==='新增' ">
              <el-input
                @change="hasChange"
                v-model.trim="formData.filter_mn"
                :disabled="isView"
                placeholder="请输入净化器监控编码后8位后进行补全">
                <div slot="append" @click="addPrefix('净化器')">补全</div>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        </template>
        <el-row class="form-part">
          <el-col :span="3" class="form-part-title">
            <div class="wordWrapClass">判断参数</div>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="emissions_sill" label="油烟阈值">
              <el-input
                @change="hasChange"
                v-model.trim="formData.emissions_sill"
                :disabled="isView"
                placeholder="默认值为2"/>
            </el-form-item>
            <el-form-item prop="hydrocarbon_sill" label="非甲烷阈值">
              <el-input
                @change="hasChange"
                v-model.trim="formData.hydrocarbon_sill"
                :disabled="isView"
                placeholder="默认值为10"/>
            </el-form-item>
            <el-form-item prop="samplings" label="抽样次数">
              <el-input
                @change="hasChange"
                v-model.trim="formData.samplings"
                :disabled="isView"
                placeholder="默认值为3"/>
            </el-form-item>
            <el-form-item prop="fan_status" label="风机状态">
              <el-select v-model="formData.fan_status" placeholder="请选择风机状态" @change="hasChange" style="width: 100%">
                <el-option :label="'正常'" :value="1"></el-option>
                <el-option :label="'不正常'" :value="0"></el-option>
                <el-option :label="'未连接'" :value="2"></el-option>
                <el-option :label="'取消选择'" :value="-1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="granule_sill" label="颗粒物阈值">
              <el-input
                @change="hasChange"
                v-model.trim="formData.granule_sill"
                :disabled="isView"
                placeholder="默认值为5"/>
            </el-form-item>
            <el-form-item prop="offline_judge" label="异常判定">
              <el-input
                @change="hasChange"
                v-model.number="formData.offline_judge"
                :disabled="isView"
                placeholder="默认值为48"/>
            </el-form-item>
            <el-form-item prop="surpass_calc_method" label="折算浓度计算方式">
              <el-select
                style="width: 100%"
                @change="hasChange"
                v-model.trim="formData.surpass_calc_method"
                :disabled="isView"
                placeholder="请输入折算浓度计算方式">
                <el-option :value="1" label="抽样计算"/>
                <el-option :value="2" label="滑动计算"/>
              </el-select>
            </el-form-item>
            <el-form-item prop="filter_status" label="净化器状态">
              <el-select v-model="formData.filter_status" placeholder="请选择净化器状态" @change="hasChange" style="width: 100%">
                <el-option :label="'正常'" :value="1"></el-option>
                <el-option :label="'不正常'" :value="0"></el-option>
                <el-option :label="'未连接'" :value="2"></el-option>
                <el-option :label="'取消选择'" :value="-1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="form-part">
          <el-col :span="6" class="form-part-title">
            <div style="text-align: center;letter-spacing: 3px;font-weight: bold;">营业执照图片<span style="color:#ff0000;">*</span></div>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <el-upload
                ref="upload"
                accept=".jpg,.jpeg,.png"
                :show-file-list="false"
                :action="upload()"
                :on-success="(response, file, fileList) => { return handleAvatarSuccess(response, file, fileList, 1)}"
                :before-upload="hasChange"
                v-if="!isView"
              >
                <i class="el-icon-plus avatar-uploader-icon"/>
                <div slot="tip">（支持jpg、jpeg、png）</div>
              </el-upload>
              <div class="img-list" v-if="fileList.length">
                <div class="single-img" v-for="(item, idx) in fileList" :key="idx" v-if="item.type == 1"
                     style="position: relative; display: inline-block; margin-right: 10px;">
                  <el-image
                    style="width: 100px;height: 100px"
                    :src="item.pic"
                    :preview-src-list="fileList.filter(f => f.type == 1).map(f => f.pic)"
                    fit="fit"/>
                  <div v-if="!isView" class="remove-img el-icon-close" @click="removeImg(idx)"></div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="form-part">
          <el-col :span="6" class="form-part-title">
            <div style="text-align: center;letter-spacing: 3px;font-weight: bold;">店铺门头图片 <span style="color:#ff0000;">*</span></div>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <el-upload
                ref="upload"
                accept=".jpg,.jpeg,.png"
                :show-file-list="false"
                :action="upload()"
                :on-success="(response, file, fileList) => { return handleAvatarSuccess(response, file, fileList, 2)}"
                :before-upload="hasChange"
                v-if="!isView"
              >
                <i class="el-icon-plus avatar-uploader-icon"/>
                <div slot="tip">（支持jpg、jpeg、png）</div>
              </el-upload>
              <div class="img-list" v-if="fileList.length">
                <div class="single-img" v-for="(item, idx) in fileList" :key="idx" v-if="item.type == 2"
                     style="position: relative; display: inline-block; margin-right: 10px;">
                  <el-image
                    style="width: 100px;height: 100px"
                    :src="item.pic"
                    :preview-src-list="fileList.filter(f => f.type == 2).map(f => f.pic)"
                    fit="fit"/>
                  <div v-if="!isView" class="remove-img el-icon-close" @click="removeImg(idx)"></div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="form-part">
          <el-col :span="6" class="form-part-title">
            <div style="text-align: center;letter-spacing: 3px;font-weight: bold;">灶头整体图片</div>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <el-upload
                ref="upload"
                accept=".jpg,.jpeg,.png"
                :show-file-list="false"
                :action="upload()"
                :on-success="(response, file, fileList) => { return handleAvatarSuccess(response, file, fileList, 3)}"
                :before-upload="hasChange"
                v-if="!isView"
              >
                <i class="el-icon-plus avatar-uploader-icon"/>
                <div slot="tip">（支持jpg、jpeg、png）</div>
              </el-upload>
              <div class="img-list" v-if="fileList.length">
                <div class="single-img" v-for="(item, idx) in fileList" :key="idx" v-if="item.type == 3"
                     style="position: relative; display: inline-block; margin-right: 10px;">
                  <el-image
                    style="width: 100px;height: 100px"
                    :src="item.pic"
                    :preview-src-list="fileList.filter(f => f.type == 3).map(f => f.pic)"
                    fit="fit"/>
                  <div v-if="!isView" class="remove-img el-icon-close" @click="removeImg(idx)"></div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="form-part">
          <el-col :span="6" class="form-part-title">
            <div style="text-align: center;letter-spacing: 3px;font-weight: bold;">集烟罩图片</div>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <el-upload
                ref="upload"
                accept=".jpg,.jpeg,.png"
                :show-file-list="false"
                :action="upload()"
                :on-success="(response, file, fileList) => { return handleAvatarSuccess(response, file, fileList, 4)}"
                :before-upload="hasChange"
                v-if="!isView"
              >
                <i class="el-icon-plus avatar-uploader-icon"/>
                <div slot="tip">（支持jpg、jpeg、png）</div>
              </el-upload>
              <div class="img-list" v-if="fileList.length">
                <div class="single-img" v-for="(item, idx) in fileList" :key="idx" v-if="item.type == 4"
                     style="position: relative; display: inline-block; margin-right: 10px;">
                  <el-image
                    style="width: 100px;height: 100px"
                    :src="item.pic"
                    :preview-src-list="fileList.filter(f => f.type == 4).map(f => f.pic)"
                    fit="fit"/>
                  <div v-if="!isView" class="remove-img el-icon-close" @click="removeImg(idx)"></div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="form-part">
          <el-col :span="6" class="form-part-title">
            <div style="text-align: center;letter-spacing: 3px;font-weight: bold;">风机图片</div>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <el-upload
                ref="upload"
                accept=".jpg,.jpeg,.png"
                :show-file-list="false"
                :action="upload()"
                :on-success="(response, file, fileList) => { return handleAvatarSuccess(response, file, fileList, 5)}"
                :before-upload="hasChange"
                v-if="!isView"
              >
                <i class="el-icon-plus avatar-uploader-icon"/>
                <div slot="tip">（支持jpg、jpeg、png）</div>
              </el-upload>
              <div class="img-list" v-if="fileList.length">
                <div class="single-img" v-for="(item, idx) in fileList" :key="idx" v-if="item.type == 5"
                     style="position: relative; display: inline-block; margin-right: 10px;">
                  <el-image
                    style="width: 100px;height: 100px"
                    :src="item.pic"
                    :preview-src-list="fileList.filter(f => f.type == 5).map(f => f.pic)"
                    fit="fit"/>
                  <div v-if="!isView" class="remove-img el-icon-close" @click="removeImg(idx)"></div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="form-part">
          <el-col :span="6" class="form-part-title">
            <div style="text-align: center;letter-spacing: 3px;font-weight: bold;">净化器图片</div>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <el-upload
                ref="upload"
                accept=".jpg,.jpeg,.png"
                :show-file-list="false"
                :action="upload()"
                :on-success="(response, file, fileList) => { return handleAvatarSuccess(response, file, fileList, 6)}"
                :before-upload="hasChange"
                v-if="!isView"
              >
                <i class="el-icon-plus avatar-uploader-icon"/>
                <div slot="tip">（支持jpg、jpeg、png）</div>
              </el-upload>
              <div class="img-list" v-if="fileList.length">
                <div class="single-img" v-for="(item, idx) in fileList" :key="idx" v-if="item.type == 6"
                     style="position: relative; display: inline-block; margin-right: 10px;">
                  <el-image
                    style="width: 100px;height: 100px"
                    :src="item.pic"
                    :preview-src-list="fileList.filter(f => f.type == 6).map(f => f.pic)"
                    fit="fit"/>
                  <div v-if="!isView" class="remove-img el-icon-close" @click="removeImg(idx)"></div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="form-part">
          <el-col :span="6" class="form-part-title">
            <div style="text-align: center;letter-spacing: 3px;font-weight: bold;">监测仪图片</div>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <el-upload
                ref="upload"
                accept=".jpg,.jpeg,.png"
                :show-file-list="false"
                :action="upload()"
                :on-success="(response, file, fileList) => { return handleAvatarSuccess(response, file, fileList, 7)}"
                :before-upload="hasChange"
                v-if="!isView"
              >
                <i class="el-icon-plus avatar-uploader-icon"/>
                <div slot="tip">（支持jpg、jpeg、png）</div>
              </el-upload>
              <div class="img-list" v-if="fileList.length">
                <div class="single-img" v-for="(item, idx) in fileList" :key="idx" v-if="item.type == 7"
                     style="position: relative; display: inline-block; margin-right: 10px;">
                  <el-image
                    style="width: 100px;height: 100px"
                    :src="item.pic"
                    :preview-src-list="fileList.filter(f => f.type == 7).map(f => f.pic)"
                    fit="fit"/>
                  <div v-if="!isView" class="remove-img el-icon-close" @click="removeImg(idx)"></div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="form-part">
          <el-col :span="6" class="form-part-title">
            <div style="text-align: center;letter-spacing: 3px;font-weight: bold;">其他照片</div>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <el-upload
                ref="upload"
                accept=".jpg,.jpeg,.png"
                :show-file-list="false"
                :action="upload()"
                :on-success="(response, file, fileList) => { return handleAvatarSuccess(response, file, fileList, 8)}"
                :before-upload="hasChange"
                v-if="!isView"
              >
                <i class="el-icon-plus avatar-uploader-icon"/>
                <div slot="tip">（支持jpg、jpeg、png）</div>
              </el-upload>
              <div class="img-list" v-if="fileList.length">
                <div class="single-img" v-for="(item, idx) in fileList" :key="idx" v-if="item.type == 8"
                     style="position: relative; display: inline-block; margin-right: 10px;">
                  <el-image
                    style="width: 100px;height: 100px"
                    :src="item.pic"
                    :preview-src-list="fileList.filter(f => f.type == 8).map(f => f.pic)"
                    fit="fit"/>
                  <div v-if="!isView" class="remove-img el-icon-close" @click="removeImg(idx)"></div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" @click="visible = false"
      >取消
      </el-button
      >
      <el-button type="primary" size="mini" @click.native="handleSubmit"
      >提交
      </el-button
      >
    </div>
  </el-dialog>
</template>
<script>

import conf from "@/config";
import {mapState} from "vuex";
import {getUserInfo, join, ownerJoin} from "@/util";
import {loadCustomer} from "../util/index"

export default {
  name: "LocaleEditDialog",
  props: ['title', 'visible', 'state', 'formData', 'isView'],
  computed: {
    ...mapState(['areaTree', 'clientHeight', 'locale', 'customerTree']),
    ...mapState({
      props: (state) => Object.assign({}, state.props, {label: 'Org', checkStrictly: true}),
      customerProps: (state) =>
        Object.assign({}, state.props, {label: 'Org', checkStrictly: true}),
      selAreaProps: (state) =>
        Object.assign({}, state.props, {checkStrictly: true}),
      areaProps: (state) => Object.assign({}, state.props)
    })
  },
  data() {
    return {
      userInfo: '',
      changeState: false,
      cuisine: [],
      managementTypes: [],
      fileList: [],
      formRule: {
        name: [{required: true, message: '名称不可为空', trigger: 'blur'}],
        addr: [{required: true, message: '详细地址不可为空', trigger: 'blur'}],
        lng: [{required: true, message: '经度不可为空', trigger: 'blur'}],
        lat: [{required: true, message: '纬度不可为空', trigger: 'blur'}],
        area_id: [{required: true, message: '所属地区不可为空', trigger: 'blur'}],
        owner: [{required: true, message: '所属单位不可为空', trigger: 'blur'}],
        stove_area: [{required: true, message: '集气罩面积不可为空', trigger: 'blur'},{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }],
        exhaust_time: [{required: true, message: '日均排烟时间不可为空', trigger: 'blur'}],
        cuisine: [{required: true, message: '菜系不可为空', trigger: 'blur'}],
        stove_num: [{required: true, message: '基准灶头数不可为空', trigger: 'blur'},{ pattern: /^([1-9][0-9]*)$/, message: '请输入正确额格式' }],
        scale: [{required: true, message: '企业类型不可为空', trigger: 'blur'}],
        management_types: [{required: true, message: '经营类型不可为空', trigger: 'blur'}],
        fan_standard_current: [{required: true, message: '风机标准电流不可为空', trigger: 'blur'},{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }],
        filter_standard_current: [{required: true, message: '净化器标准电流不可为空', trigger: 'blur'},{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }],
        voc_factory_name: [{required: true, message: '监测仪品牌不可为空', trigger: 'blur'}],
        principle: [{required: true, message: '检测原理不可为空', trigger: 'blur'}],
        power_supply_mode: [{required: true, message: '接电方式不可为空', trigger: 'blur'}],
        voc_factory_model_id: [{required: true, message: '监测仪型号不可为空', trigger: 'blur'}],
        send_mode: [{required: true, message: '传输方式不可为空', trigger: 'blur'}],
        voc_mn: [{required: true, message: '监测仪编码', trigger: 'blur'}],
        filter_wash_day: [{required: true, message: '净化器清洗天数不可为空', trigger: 'blur'},{ pattern: /^([1-9][0-9]*)$/, message: '请选择正确格式' }],
        locale_type: [{required: true, message: '监测点类型不能为空', trigger: 'blur'}],
      },
      factoryList: [],
      factoryModelList: [],
      maintenanceList: [],
      localeTypes: [],
      localeTypeList: [],
      status: null
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    "formData.type": {
      handler: function (val) {
        this.selectChange()
      }
    },
    "formData.locale_pics": {
      handler: function (val) {
        this.fileList = []
        if (val) {
          this.fileList = Array.from(this.formData.locale_pics)
        } else {
          this.fileList = []
        }
      }
    },
    title: {
      handler: function (val) {
        if (val === '新增') {
          this.formData.type == 1
          this.fileList = []
        }
      }
    },
    "formData.voc_factory_name": {
      handler: function (val) {
        let param = {
          StartAt: 0,
          Size: 20,
          Param:
            {
              FactoryName: val,
              ModelType: 1
            }
        }
        this.$post('admin/listFactoryModel', param).then(res => {
          this.factoryModelList = res.content
        })
      }
    }
  },
  methods: {
    //补全监测仪编码、净化器监控编码、风机监控编码  监测仪补F0 监控补D0
    addPrefix(type) {
      if (type === '监测仪') { // 此时补全监测仪
        if (this.formData.voc_mn.includes('010000A8900016F0')) {
          this.$message({
            message: '您已补全监测仪设备编码！',
            type: 'warning'
          });
          return;
        }
        if (this.formData.voc_mn.length !== 8) { // 当设备为8位的时候才能补全
          this.$message({
            message: '请输入监测仪设备后8位进行补全',
            type: 'warning'
          });
          return;
        }
        this.formData.voc_mn = '010000A8900016F0' + this.formData.voc_mn;
      } else if (type === '净化器') {
        if (this.formData.filter_mn.includes('010000A8900016D0')) {
          this.$message({
            message: '您已补全净化器设备编码！',
            type: 'warning'
          });
          return;
        }
        if (this.formData.filter_mn.length !== 8) { // 当设备为8位的时候才能补全
          this.$message({
            message: '请输入净化器设备后8位进行补全',
            type: 'warning'
          });
          return;
        }
        this.formData.filter_mn = '010000A8900016D0' + this.formData.filter_mn;
      } else if (type === '风机') {
        if (this.formData.fan_mn.includes('010000A8900016D0')) {
          this.$message({
            message: '您已补全风机设备编码！',
            type: 'warning'
          });
          return;
        }
        if (this.formData.fan_mn.length !== 8) { // 当设备为8位的时候才能补全
          this.$message({
            message: '请输入风机设备后8位进行补全',
            type: 'warning'
          });
          return;
        }
        this.formData.fan_mn = '010000A8900016D0' + this.formData.fan_mn;
      }
      // 触发表单变化事件
      this.hasChange();
    },
    shouldDisableOption(index) {
      if (this.formData.type === 2) {
        return index === 0;
      } else if (this.formData.type === 1) {
        return index === 1;
      }
    },
    selectChange(){
      for(var i = 0; i < this.localeTypeList.length; i++) {
        if (this.localeTypeList[i].id == this.formData.locale_type) {
          this.formData.type = this.localeTypeList[i].type
          break
        }
      }
      if (this.formData.type == 1) {
        this.formRule.stove_area = [{required: true, message: '集气罩面积不可为空', trigger: 'blur'},{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }]
        this.formRule.exhaust_time = [{required: true, message: '日均排烟时间不可为空', trigger: 'blur'}]
        this.formRule.cuisine = [{required: true, message: '菜系不可为空', trigger: 'blur'}]
        this.formRule.fan_standard_current = [{required: true, message: '风机标准电流不可为空', trigger: 'blur'},{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }]
        this.formRule.filter_standard_current = [{required: true, message: '净化器标准电流不可为空', trigger: 'blur'},{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }]
        this.formRule.voc_factory_name = [{required: true, message: '监测仪品牌不可为空', trigger: 'blur'}]
        this.formRule.principle = [{required: true, message: '检测原理不可为空', trigger: 'blur'}]
        this.formRule.power_supply_mode = [{required: true, message: '接电方式不可为空', trigger: 'blur'}]
        this.formRule.voc_factory_model_id = [{required: true, message: '监测仪型号不可为空', trigger: 'blur'}]
        this.formRule.send_mode = [{required: true, message: '传输方式不可为空', trigger: 'blur'}]
        this.formRule.voc_mn = [{required: true, message: '监测仪编码', trigger: 'blur'}]
      } else {
        this.formRule.stove_area = [{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }]
        this.formRule.exhaust_time = []
        this.formRule.cuisine = []
        this.formRule.fan_standard_current = [{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }]
        this.formRule.filter_standard_current = [{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }]
        this.formRule.principle = []
        this.formRule.power_supply_mode = []
        this.formRule.send_mode = []
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate(['stove_area', 'exhaust_time', 'cuisine','fan_standard_current','filter_standard_current','principle','power_supply_mode','send_mode']);
      });
    },
    init() {
      this.fileList = []
      const user = getUserInfo()
      this.userInfo = user.Info
      this.$get('admin/listAllCuisine').then((res) => {
        var data = []
        var keys = []
        for (var i = 0; i < res.length; i++) {
          var index = keys.indexOf(res[i].ResourceName)
          if (index == -1) {
            keys.push(res[i].ResourceName)
            data.push({
              value: res[i].ResourceName,
              label: res[i].ResourceName,
              children:[{
                value: res[i].Id,
                label: res[i].Name,
              }]
            })
          } else {
            data[index].children.push({
              value: res[i].Id,
              label: res[i].Name,
            })
          }
        }
        this.cuisine = data
      })
      this.$get('admin/management').then((res) => {
        var data = []
        var keys = []
        this.managementList = res.list
        for (var i = 0; i < res.list.length; i++) {
          var index = keys.indexOf(res.list[i].type)
          if (index == -1) {
            keys.push(res.list[i].type)
            data.push({
              value: res.list[i].type == 1?"经营性":"非经营性",
              label: res.list[i].type == 1?"经营性":"非经营性",
              children:[{
                value: res.list[i].id,
                label: res.list[i].name,
              }]
            })
          } else {
            data[index].children.push({
              value: res.list[i].id,
              label: res.list[i].name,
            })
          }
        }
        this.managementTypes = data
      })
      this.$post('admin/listFactory', {}).then(res => {
        this.factoryList = res.content
      })
      this.$get("admin/listMaintainer").then((res) => {
        this.maintenanceList = res;
      });
      var data = [{
        label: '监测类',
        options: []
      }, {
        label: '非监测类',
        options: []
      }]
      this.$get('admin/locale_type', {}).then(res => {
        this.localeTypeList = res.list
        for (var i = 0; i < res.list.length; i++) {
          if (res.list[i].type == 1) {
            res.list[i].typeName = "监测类"
            data[0].options.push({
              value: res.list[i].id,
              label: res.list[i].name
            })
          } else {
            data[1].options.push({
              value: res.list[i].id,
              label: res.list[i].name
            })
          }
        }
        this.localeTypes = data
      })
    },
    async handleEditDialogClose() {
      if (this.changeState) {
        this.changeState = false
      }
      this.handleClose()
    },
    hasChange() {
      this.changeState = true
    },
    handlePaste() {
      this.changeState = true
      const arr = this.formData.lng.split(',')
      this.formData.lng = arr[0]
      this.formData.lat = arr[1]
    },
    handleOwnerChange(v) {
      this.changeState = true
    },
    /**
     * 监测仪品牌选择后调用
     * @param value
     */
    handleFactorySelect(value) {
      this.changeState = true
      this.formData.voc_factory_model_id = ""
      let param = {
        StartAt: 0,
        Size: 20,
        Param:
          {
            FactoryName: value,
            ModelType: 1
          }
      }
      this.$post('admin/listFactoryModel', param).then(res => {
        this.factoryModelList = res.content
      })
    },
    upload() {
      return conf.uploadApi + '/uploadToOss'
    },
    removeImg(idx) {
      this.changeState = true
      this.fileList.splice(idx, 1)
    },
    handleAvatarSuccess(res, file, fileList, type) {
      this.fileList.push({pic:res.Data, type: type})
    },
    handleSubmit() {
      if (!this.changeState && this.title !== '审核') {
        this.$emit("handleClose")
        return
      }
      var managePics = []
      var shopPic = []
      // var stovePic = []
      // var areaPic = []
      // var fanPic = []
      // var filterPic = []
      // var vocPic = []
      for(var i = 0; i < this.fileList.length; i ++) {
        if (this.fileList[i].type == 1) {
          managePics.push(this.fileList[i].pic)
        }
        if (this.fileList[i].type == 2) {
          shopPic.push(this.fileList[i].pic)
        }
      //   if (this.fileList[i].type == 3) {
      //     stovePic.push(this.fileList[i].pic)
      //   }
      //   if (this.fileList[i].type == 4) {
      //     areaPic.push(this.fileList[i].pic)
      //   }
      //   if (this.fileList[i].type == 5) {
      //     fanPic.push(this.fileList[i].pic)
      //   }
      //   if (this.fileList[i].type == 6) {
      //     filterPic.push(this.fileList[i].pic)
      //   }
      //   if (this.fileList[i].type == 7) {
      //     vocPic.push(this.fileList[i].pic)
      //   }
      }
      if (this.title === '新增') {
        if (managePics.length == 0) {
          this.$message({
            message: '营业执照图片不能为空',
            type: 'info'
          });
          return
        }

        if (shopPic.length == 0) {
          this.$message({
            message: '店铺门头图片不能为空',
            type: 'info'
          });
          return
        }
      }
      // if (stovePic.length == 0) {
      //   this.$message({
      //     message: '灶头整体图片不能为空',
      //     type: 'info'
      //   });
      //   return
      // }
      // if (areaPic.length == 0) {
      //   this.$message({
      //     message: '集烟罩图片不能为空',
      //     type: 'info'
      //   });
      //   return
      // }
      // if (fanPic.length == 0) {
      //   this.$message({
      //     message: '风机图片不能为空',
      //     type: 'info'
      //   });
      //   return
      // }
      // if (filterPic.length == 0) {
      //   this.$message({
      //     message: '净化器图片不能为空',
      //     type: 'info'
      //   });
      //   return
      // }
      // if (vocPic.length == 0) {
      //   this.$message({
      //     message: '监测仪图片不能为空',
      //     type: 'info'
      //   });
      //   return
      // }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {})
            .then(() => {
              const para = Object.assign({}, this.formData)
              if (para.id) {
                para.locale_id = para.id
              }
              let userInfo = getUserInfo().Info
              para.owner = ownerJoin(this.formData.owner, userInfo)
              para.area_id = join(para.area_id)
              if (this.fileList.length > 0) {
                para.pics = JSON.stringify(this.fileList)
              }
              let param = new URLSearchParams()
              Object.entries(para).forEach(([key, val]) => {
                if (key == 'cuisine') {
                  if (val.length > 1) {
                    param.append(key, val[1])
                  } else {
                    if (this.formData.type == 1) {
                      this.$message({
                        message: '菜系选择有误',
                        type: 'info'
                      });
                      return false
                    }
                  }
                } else if (key == 'management_types') {
                  if (val.length > 1) {
                    param.append(key, val[1])
                  } else {
                    this.$message({
                      message: '经营类型选择有误',
                      type: 'info'
                    });
                    return
                  }
                } else {
                  if (key != "type") {
                    param.append(key, val)
                  }
                }
              })
              if (this.title === '新增') {
                this.$post('admin/locale/add', param).then(res => {
                  this.$message({
                    message: '添加成功',
                    type: 'success'
                  });
                  this.$emit("handleClose")
                })
              } else if (this.title === '编辑') {
                this.$post('admin/locale/update', param).then(res => {
                  this.$message({
                    message: '修改成功',
                    type: 'success'
                  });
                  loadCustomer(this,this.$message.success(`所属单位信息加载成功`))
                  this.$emit("handleClose")
                })
              }

            })
        }
      })
    },
    handleClose() {
      this.fileList = []
      this.$emit("handleClose")
    },
    handleFactoryModelChange(val) {
      this.$forceUpdate()
    },
    statusChange(val) {
      if (val === "正常") {
        this.formData.status_of_record = "NORMAL"
      } else if (val === "下线") {
        this.formData.status_of_record = "OFFLINE"
      } else if (val === "歇业") {
        this.formData.status_of_record = "REST"
      }
    },
    // imgExceed(files, fileList) {
    //   this.$message({
    //     type: "error",
    //     message: "图片上传数目超过限制！"
    //   })
    // }
  }
}
</script>
<style scoped lang="scss">
.form-part {
  display: flex;
  padding: 20px 0 20px 0;
  margin-bottom: 20px;
  border-width: 1px;
  border-style: solid;
  border-radius: 10px;
  border-color: #eeeeee;
}

.form-part-title {
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #EBEEF5
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 78px;
  height: 78px;
  line-height: 78px;
  text-align: center;
}

.single-img > img {
  width: 100px;
  height: 100px;
}


.wordWrapClass {
  vertical-align: center;
  writing-mode: vertical-lr;
  text-align: center;
  letter-spacing: 6px;
  font-weight: bold;

}
//给监测仪编码补全设置的样式
/deep/ .el-input-group__append, .el-input-group__prepend {
  font-style: normal !important;
  padding: 0px 8px 0px 8px !important;
  cursor: pointer !important;
}
</style>
